module.exports = __webpack_public_path__ + "media/img/teste-3c86fc23.png";